<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">Associar usuários e dados</h1>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label>Selecione o usuário</label>
            <v-select
              ref="usuario-ativo"
              class=""
              v-model="userActive"
              @input="selectUser(userActive)"
              :clearable="false"
              :getOptionLabel="(option) => `${option.nome} - ${(option.email || '')}`"
              :reduce="user => user.codigo"
              placeholder="PESQUISE O NOME DO USUÁRIO AQUI..."
              :options="users"
              :selectOnTab="true"
            >
              <template slot="no-options">
                Usuário não encontrado...
              </template>
            </v-select>
          </div>
        </div>
        <div class="col-xs-12 form-group">
          <button class="btn btn-default" @click="newUser">
            <font-awesome-icon :icon="'plus'"/> Adicionar usuários
          </button>
        </div>
        <section v-for="item in Object.keys(otherUsers)" :key="item">
          <div class="col-xs-12 form-group">
            <label>Selecione o usuário</label>
            <v-select
              ref="outros-usuarios"
              class=""
              v-model="otherUsers[item]"
              :getOptionLabel="(option) => `${option.nome} - ${(option.email || '')}`"
              :reduce="user => user.codigo"
              :placeholder="'Selecione o usuário'"
              :options="users"
              :selectOnTab="true"
            >
              <template slot="no-options">
                Usuário não encontrado...
              </template>
            </v-select>
          </div>
        </section>
        <div v-if="multiplosUsuarios.length > 0" class="col-xs-12 form-group">
          <button class="btn btn-default" @click="associarDados" :disabled="carregando">
            <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
            <font-awesome-icon v-else :icon="'save'" />
            {{ carregando ? 'Associando...' : 'Associar aos usuários ' }}
          </button>
        </div>

        <div class="col-xs-12 col-sm-6">
          <list
            ref="dt_associado"
            :show-empty="true"
            :show-print-button="false"
            :show-column-visibility-button="false"
            :load-on-start="false"
            title="Dados associados"
            api-url="dado/listbyuser"
            report-title="Dados associados"
            :fields="columns"
            :pageCollection="'dadosAssociados'"
            :initial-page="paginaAssociados"
            :appendParams="associadoFiltros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-xs-12 form-group">
                  <label for="username_filter">Nome</label>
                  <input
                    type="text"
                    v-model="associadoNome"
                    @keyup.enter="loadDadosAssociados()"
                    class="form-control"
                  />
                </div>
                <div class="col-xs-12">
                  <button
                    @click="loadDadosAssociados()"
                    class="btn btn-default"
                  >
                    <font-awesome-icon :icon="'filter'"/> Filtrar
                  </button>
                  <button
                    @click="limparDadoAssociado()"
                    class="btn btn-default"
                  >
                    <font-awesome-icon :icon="'eraser'"/> Limpar Filtros
                  </button>
                  <button class="btn btn-default" @click="desassociarTodos" :disabled="carregando">
                    <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
                    <font-awesome-icon v-else :icon="'times'" />
                    {{ carregando ? 'Desassociando...' : 'Desassociar tudo' }}
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"/> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Desassociar"
                  class="btn btn-danger"
                  @click="desassociar(props.rowData)"
                >
                  <font-awesome-icon :icon="'times'"/>
                </button>
              </div>
            </template>
          </list>
        </div>

        <div class="col-xs-12 col-sm-6">
          <list
            ref="dt_associar"
            :show-empty="true"
            :load-on-start="false"
            :show-print-button="false"
            :show-column-visibility-button="false"
            title="Dados para associar"
            api-url="dado/list-associate-user"
            report-title="Dados por usuário"
            :fields="columns"
            :pageCollection="'dadosParaAssociar'"
            :initial-page="paginaParaAssociar"
            :appendParams="associarFiltros"
          >
            <template slot="filters">
              <div class="collapse" id="associar-filtros">
                <div class="col-xs-12 form-group">
                  <label for="username_filter">Nome</label>
                  <input
                    type="text"
                    v-model="associarNome"
                    @keyup.enter="loadDadosAssociar()"
                    class="form-control"
                  />
                </div>
                <div class="col-xs-12 form-group">
                  <label>Secretaria</label>
                  <v-select
                    ref="secretaria_codigo_filter"
                    v-model="associarSecretaria"
                    @input="loadDadosAssociar()"
                    :label="'sigla'"
                    :reduce="i => i.codigo"
                    :placeholder="'Selecione a secretaria'"
                    :options="secretarias"
                    :selectOnTab="true"
                  >
                    <template slot="no-options">
                      Secretaria não encontrada...
                    </template>
                  </v-select>
                </div>
                <div class="col-xs-12">
                  <button
                    @click="loadDadosAssociar()"
                    class="btn btn-default"
                  >
                    <font-awesome-icon :icon="'filter'"/> Filtrar
                  </button>
                  <button
                    @click="limparDadoAssociar()"
                    class="btn btn-default"
                  >
                    <font-awesome-icon :icon="'eraser'"/> Limpar Filtros
                  </button>
                  <button
                    @click="associarTodos"
                    class="btn btn-default"
                  >
                    <font-awesome-icon :icon="'save'"/> Adicionar Todos
                  </button>

                </div>
              </div>
            </template>
            <template slot="actions">
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#associar-filtros"
              >
                <font-awesome-icon :icon="'filter'"/> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Associar"
                  type="button"
                  class="btn btn-success"
                  @click="associar(props.rowData)"
                >
                  <font-awesome-icon :icon="'plus'"/>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  name: 'user-associate',
  inject: ["showConfirm"],
  data() {
    return {
      carregando: false,
      users: [],
      userActive: '',
      otherUsers: {},
      associadoNome: '',
      associarNome: '',
      associarSecretaria: '',
      secretarias: [],
      columns: [
        {
          name: 'nome',
          title: 'Nome',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    request
      .get('listar-secretarias-associadas')
      .then(({ data }) => {
        if (data.status) {
          this.secretarias = data.data
        }
      })
      .catch(() => {
        this.$toastr.e(
          'Houve uma falha ao tentar carregar o filtro secretarias!'
        )
      })

    request
      .get('user/list/all')
      .then(response => {
        this.loadUsers(response.data)
      })
      .catch(error => {
        console.log(error.response)
      })
  },
  computed: {
    associadoFiltros() {
      return {
        userid: this.userActive,
        nome: this.associadoNome
      }
    },
    associarFiltros() {
      return {
        userid: this.userActive,
        nome: this.associarNome,
        secretaria: this.associarSecretaria
      }
    },
    paginaAssociados: {
      get() {
        const { dadosAssociados } = this.$store.state.vuetableState
        const { pagina } = dadosAssociados
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dadosAssociados',
          value: value
        })
      }
    },
    paginaParaAssociar: {
      get() {
        const { dadosParaAssociar } = this.$store.state.vuetableState
        const { pagina } = dadosParaAssociar
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'dadosParaAssociar',
          value: value
        })
      }
    },
    multiplosUsuarios() {
      const usuarios = Object.keys(this.otherUsers)
      let ids = []

      for (let index = 0; index < usuarios.length; index++) {
        const element = this.otherUsers[usuarios[index]]

        if (element && !ids.includes(element) && this.userActive !== element) {
          ids.push(element)
        }
      }

      return ids
    }
  },
  methods: {
    newUser() {
      const userNumber = Object.keys(this.otherUsers).length + 1
      this.otherUsers = {...this.otherUsers, [`user${userNumber}`]: ''}
    },
    associarDados() {
      const config = {
        title: 'Atenção',
        question: true,
        yes: () => {
          this.associarVarios()
        }
      }
      this.showConfirm(
        'Deseja associar os mesmos dados aos usuários selecionados? Qualquer dado associado anteriormente será removido.',
        config
      )
    },
    loadUsers(data) {
      this.users = data
      // if (this.users.length > 0) {
      //   this.selectUser(this.users[0].codigo)
      // }
    },
    selectUser(id) {
      this.userActive = id
      this.otherUsers = {}
      this.loadDadosAssociados()
      this.loadDadosAssociar()
    },
    loadDadosAssociados() {
      this.$nextTick(() => {
        this.$refs.dt_associado.refresh()
      })
    },
    loadDadosAssociar() {
      this.$nextTick(() => {
        this.$refs.dt_associar.refresh()
      })
    },
    loadDados() {
      this.loadDadosAssociados()
      this.loadDadosAssociar()
    },
    associarVarios() {
      this.carregando = true
      request
        .post(
          'dado/associar-varios',
          { idusuario: this.userActive, listausuarios: this.multiplosUsuarios }
        )
        .then(response => {
          this.$toastr.s(response.data.msg)
        })
        .catch(error => {
          this.$toastr.e('Houve um erro ao associar dados. Tenta novamente ou contate o administrador')
          console.log(error.response)
        })
        .then(() => {
          this.carregando = false
        })
    },
    associar(item) {
      request
        .post(
          'dado/associar',
          { dadoid: item.codigo, userid: this.userActive }
        )
        .then(response => {
          if (response.data.status) {
            this.loadDados()
            this.$toastr.s('Dado associado com sucesso')
          } else {
            this.$toastr.e(
              'Houve uma falha ao tentar associar o dado, por favor tente novamente daqui alguns minutos!'
            )
          }
        })
        .catch(error => console.log(error.response))
    },
    associarTodos() {
      const salvar = () => {
        request
          .post(
            'dado/associar-todos',
            this.associarFiltros
          )
          .then(response => {
            const { data } = response
            if (data.status) {
              this.$refs.dt_associado.refresh()
              this.$refs.dt_associar.refresh()
            }

            this.$toastr.s(data.msg)
          })
          .catch(error => {
            this.$toastr.e('Houve um erro ao associar os dados. Tente novamente e, caso o problema persista, contate o administrador.')
            console.log(error.response)
          })
      }

      const config = {
        title: 'Atenção',
        question: true,
        yes: () => {
          salvar()
        }
      }
      this.showConfirm(
        'Deseja associar TODOS OS DADOS LISTADOS para o usuário selecionado?',
        config
      )
    },
    desassociarTodos() {
      const salvar = () => {
        request
          .post(
            'dado/desassociar-todos',
            { userid: this.userActive }
          )
          .then(response => {
            const { data } = response
            if (data.status) {
              this.$refs.dt_associado.refresh()
              this.$refs.dt_associar.refresh()
            }

            this.$toastr.s(data.msg)
          })
          .catch(error => {
            this.$toastr.e('Houve um erro ao desassociar os dados. Tente novamente e, caso o problema persista, contate o administrador.')
            console.log(error.response)
          })
      }

      const config = {
        title: 'Atenção',
        question: true,
        yes: () => {
          salvar()
        }
      }
      this.showConfirm(
        'Deseja desassociar TODOS OS DADOS LISTADOS para o usuário selecionado?',
        config
      )
    },
    
    desassociar(item) {
      request
        .post(
          'dado/desassociar',
          { dadoid: item.codigo, userid: this.userActive }
        )
        .then(response => {
          if (response.data.status) {
            this.loadDados()
            this.$toastr.s('Dado desassociado com sucesso')
          } else {
            this.$toastr.e(
              'Houve uma falha ao tentar desassociar o dado, por favor tente novamente daqui alguns minutos!'
            )
          }
        })
        .catch(error => console.log(error.response))
    },
    limparDadoAssociado() {
      this.associadoNome = ''
      this.associarSecretaria = ''
      this.loadDadosAssociados()
    },
    limparDadoAssociar() {
      this.associarNome = ''
      this.associarSecretaria = ''
      this.loadDadosAssociar()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/users/Associate.vue